///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuiTranslateDirective } from '@siklu/sui-lib';

@Component({
    selector: 'winde-tabs-nav',
    templateUrl: './tabs-nav.component.html',
    styleUrls: ['./tabs-nav.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SuiTranslateDirective]
})
export class TabsNavComponent<T> implements OnInit {
    @Input() tabsList: T[];
    @Input() translationPrefix: string;
    @Input() translationParamsMap: Map<T, Record<string, string>>;
    @Input() customClass: string;
    @Input() showClose = false;
    @Output() tabChanged = new EventEmitter<T>();
    @Output() tabClosed = new EventEmitter<T>();
    public activeToShow = 0;

    @Input() set activeTab(activeTab: number) {
        if (!activeTab) {
            this.activeToShow = 0;
        } else {
            this.activeToShow = activeTab;
        }
    }

    ngOnInit() {
        this.customClass = this.customClass || 'tabs-nav--horizontal';
    }

    public changeTab(tab: T) {
        this.tabChanged.emit(tab);
    }

    public closeTab(event, tab: T) {
        event.stopPropagation();
        this.tabClosed.emit(tab);
    }

    public trackByIndex(index: number) {
        return index;
    }
}
